import BaseInputDate from 'app/components/forms/base_inputDate/component'
import { nullValidator, withValidation } from 'app/components/forms/util'

const InputStartDate = withValidation(BaseInputDate, nullValidator)

export default InputStartDate
